export default {
    setBrands(state, payload) {
        state.brand = payload;
    },
    setBrandById(state, payload) {
        state.brandById = payload;
    },
    setProducts(state, payload) {
        state.product = payload;
    },
    setProductById(state, payload) {
        state.productById = payload;
    },
}